import { z } from 'zod';
export const validationDocumentTypeSchema = z.enum(['IdentityDocument', 'CompanyAssuranceDocument']);
export const ValidationDocumentType = validationDocumentTypeSchema.enum;
// A craftsman uploads the front and the back of one ID; Partner Management may collect more assurance papers. Which
// side an image shows is deliberately not recorded — BackOps looks at both regardless.
export const MAX_VALIDATION_DOCUMENTS_PER_TYPE = {
    [ValidationDocumentType.IdentityDocument]: 2,
    [ValidationDocumentType.CompanyAssuranceDocument]: 5,
};
export const VALIDATION_DOCUMENT_MAX_SIZE_MB = 5;
const BYTES_PER_MB = 1024 * 1024;
export const VALIDATION_DOCUMENT_MAX_BYTES = VALIDATION_DOCUMENT_MAX_SIZE_MB * BYTES_PER_MB;
/**
 * Exact types rather than an `image/*` wildcard: a human in BackOps reads these, so every accepted type has to render
 * in a browser without a conversion step. That rules out HEIC, which an iPhone would otherwise offer, and SVG.
 */
export const VALIDATION_DOCUMENT_MIME_TYPES = {
    [ValidationDocumentType.IdentityDocument]: ['image/png', 'image/jpeg', 'application/pdf'],
    [ValidationDocumentType.CompanyAssuranceDocument]: ['image/png', 'image/jpeg', 'application/pdf'],
};
// The trail has to tell the purge on closure apart from someone removing a wrong upload.
export const validationDocumentDeletionReasonSchema = z.enum(['RemovedByUser', 'PurgedOnClosure']);
export const ValidationDocumentDeletionReason = validationDocumentDeletionReasonSchema.enum;
export const addValidationDocumentSchema = z.object({
    type: validationDocumentTypeSchema,
});
export function isValidationDocumentMimeTypeAllowed(type, mimeType) {
    return VALIDATION_DOCUMENT_MIME_TYPES[type].includes(mimeType.trim().toLowerCase());
}
export function validateValidationDocumentFile(type, file, existingCount = 0) {
    const maxCount = MAX_VALIDATION_DOCUMENTS_PER_TYPE[type];
    if (existingCount >= maxCount) {
        return { reason: 'too_many', type, maxCount };
    }
    if (!isValidationDocumentMimeTypeAllowed(type, file.type)) {
        return { reason: 'unsupported_type', fileName: file.name };
    }
    if (file.size > VALIDATION_DOCUMENT_MAX_BYTES) {
        return { reason: 'too_large', fileName: file.name, maxSizeMb: VALIDATION_DOCUMENT_MAX_SIZE_MB };
    }
    return undefined;
}
